import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { landingsSelectors } from '../../../../store/modules/landings';
import { streamActions } from '../../../../store/modules/stream';

const useFetchWebinar = () => {
  const dispatch = useDispatch();
  const streamId = useSelector(landingsSelectors.selectWebinarStreamId);

  useEffect(() => {
    streamId && dispatch(streamActions.fetchStream(streamId));
  }, [streamId]);
};

export default useFetchWebinar;
